var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61653 3.86314C5.13234 3.37895 4.34732 3.37895 3.86314 3.86314C3.37895 4.34732 3.37895 5.13234 3.86314 5.61653L6.84385 8.59724C7.61855 9.37194 7.61852 10.628 6.84382 11.4027L3.86314 14.3835C3.37895 14.8677 3.37895 15.6527 3.86314 16.1369C4.34732 16.621 5.13234 16.621 5.61653 16.1369L8.60875 13.1446C9.38433 12.3814 10.6318 12.3852 11.4026 13.1561L14.3835 16.1369C14.8677 16.621 15.6527 16.621 16.1369 16.1369C16.621 15.6527 16.621 14.8677 16.1369 14.3835L13.1465 11.3931C12.3851 10.6216 12.3845 9.3812 13.1446 8.60881L16.1369 5.61653C16.621 5.13234 16.621 4.34732 16.1369 3.86314C15.6527 3.37895 14.8677 3.37895 14.3835 3.86314L11.4027 6.84393C10.6312 7.61545 9.38221 7.61857 8.60677 6.85338L5.61653 3.86314Z",
    fill: "#AA8208"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.0f309e7afc2b1a8d38ea7849083b0d8a.svg";
export { ForwardRef as ReactComponent };